// extracted by mini-css-extract-plugin
export var grid = "video-module--grid--589a5";
export var gridWithRowGap = "video-module--grid--with-row-gap--b9b96";
export var maxWidthContainer = "video-module--max-width-container--f5629";
export var mt0 = "video-module--mt-0--d8f9a";
export var mt1 = "video-module--mt-1--c13d5";
export var mt2 = "video-module--mt-2--72ad7";
export var mt3 = "video-module--mt-3--cde40";
export var mt4 = "video-module--mt-4--14c1a";
export var mt5 = "video-module--mt-5--0a106";
export var mt6 = "video-module--mt-6--c8ebd";
export var removeVisuallyHidden = "video-module--remove-visually-hidden--6bd70";
export var video = "video-module--video--33ec0";
export var videoPortrait = "video-module--video--portrait--97dbe";
export var video__button = "video-module--video__button--2f84a";
export var video__caption = "video-module--video__caption--5001e";
export var video__captionWrapper = "video-module--video__caption-wrapper--6a2a1";
export var video__icon = "video-module--video__icon--19b06";
export var video__player = "video-module--video__player--d5bda";
export var video__playerInline = "video-module--video__player--inline--664de";
export var video__playerPortrait = "video-module--video__player--portrait--044fd";
export var video__thumbnail = "video-module--video__thumbnail--7f084";
export var visuallyHidden = "video-module--visually-hidden--b43a3";
export var widgetBase = "video-module--widget-base--d7610";